import { render, staticRenderFns } from "./SectionType.vue?vue&type=template&id=22ef8a10&scoped=true&"
import script from "./SectionType.vue?vue&type=script&lang=js&"
export * from "./SectionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ef8a10",
  null
  
)

export default component.exports